"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiInputAdornment = void 0;
exports.MuiInputAdornment = {
    root: {
        '& > .MuiIconButton-root': {
            '&:focus': {
                backgroundColor: 'transparent',
            },
        },
    },
};
